// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let ReasonPromise = require("../reason/ReasonPromise.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");

function fromJsPromise(v) {
  return ReasonPromise.Js.toResult(ReasonPromise.Js.fromBsPromise(v));
}

function toJsPromise(v) {
  return ReasonPromise.Js.toBsPromise(ReasonPromise.Js.fromResult(v));
}

function fromPromiseRejection(v) {
  return {
    name: Primitive_option.fromNullable(v.name),
    message: Primitive_option.fromNullable(v.message)
  };
}

let JsPromiseRejection = {
  fromPromiseRejection: fromPromiseRejection
};

exports.fromJsPromise = fromJsPromise;
exports.toJsPromise = toJsPromise;
exports.JsPromiseRejection = JsPromiseRejection;
/* ReasonPromise Not a pure module */
